<img
  class="c-text-link-external"
  [src]="getIndicatorSrc"
  [width]="sizePx"
  [height]="sizePx"
  alt="{{ 'alt.openLinkInNewTab' | staticMsg }}"
/>
